import { render, staticRenderFns } from "./ProcuratorCreditorSummary.vue?vue&type=template&id=1959225c&scoped=true&"
import script from "./ProcuratorCreditorSummary.vue?vue&type=script&lang=js&"
export * from "./ProcuratorCreditorSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProcuratorCreditorSummary.vue?vue&type=style&index=0&id=1959225c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959225c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VExpandTransition,VIcon,VProgressLinear,VSpacer})
